module.exports = __webpack_public_path__ + "img/14f5fb6.jpg";